import { gql } from '@apollo/client';

export const shouldUseFx = gql`
    query shouldUseFx {
        shouldUseFx
    }
`;
